import axios from 'axios';
import { store } from '../store';

// `site.com?preview` will load the unpublished preview site theme.
const preview = new URLSearchParams(window.location.search).has('preview');

/**
 * Pull down the latest published theme.
 */
export function loadTheme(hash) {
  const site = process.env.REACT_APP_HOSTNAME || window.location.hostname;

  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/theme/`,
    params: { hash, site },
  }).then(({ data }) => {
    if (!data.agentScript) {
      store.dispatch({ type: 'CLOSE_SCRIPT' });
    }
    store.dispatch({ type: 'LOAD_THEME', theme: data });
    return data;
  });
}

/**
 * Check for any published theme updates.
 */
export function validateTheme() {
  const site = process.env.REACT_APP_HOSTNAME || window.location.hostname;

  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/theme/versions/`,
    params: { site },
  }).then(({ data }) => {
    const current = store.getState().theme.hash;
    const hash = preview ? data.draft : data.live;

    if (hash !== current) {
      loadTheme(hash);
    }
    return (hash);
  });
}
